import React from 'react'

import PosSubscriptions from 'pages/parts/PosSubscriptions'

function Index() {
	return <PosSubscriptions mode="admin" />
}

export default Index
